import './video.scss'
import 'npm:plyr/dist/plyr.css'

import Plyr from 'plyr'

const selectors = {
  player: '#player',
  container: '.video',
  play: '[data-video-button]',
  duration: '.video__play-duration',
}

const elements = {
  player: null,
  play: null,
  duration: null,
}

const classes = {
  show: 'video_show',
}

function init() {
  elements.player = document.querySelector(selectors.player)

  if (!elements.player) return null
  elements.duration = document.querySelector(selectors.duration)
  elements.play = document.querySelector(selectors.play)

  const videoContainer = document.querySelector(selectors.container)
  const video = new Plyr(elements.player)

  elements.duration.innerText = new Date(video.duration * 1000).toISOString().substring(14, 19)

  elements.play.addEventListener('click', () => {
    videoContainer.classList.add(classes.show)

    video.play()
    video.fullscreen.enter()
    video.on('exitfullscreen', () => {
      video.stop()
      videoContainer.classList.remove(classes.show)
    })
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init()
  },
  { once: true }
)
